/**
 * APF2 CRM Backend For Frontend Api BFF common entities.
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Enum of possible master source systems
 */
export enum CustomerMasterSourceType {
  O2POP = 'O2POP',
  O2POPD = 'O2POPD',
  O2PRP = 'O2PRP',
  O2VOA = 'O2VOA',
  O2VOB = 'O2VOB',
  O2VOC = 'O2VOC',
  O2VOD = 'O2VOD',
  O2VOE01 = 'O2VOE01',
  O2VOE02 = 'O2VOE02',
  O2VOF = 'O2VOF',
  O2NON = 'O2NON',
}
